import Home from "./components/Home";
//const Menu = () => import('./components/Menu')
import About from "./components/About";
import Team from "./components/Team";
import Advocacy from './components/Advocacy';
import Contact from './components/Contact';
//const About = () => import(/* webpackChunkName: "menuGroup "*/"./components/About");
//const Contact = () =>
    //import(/* webpackChunkName: "menuGroup "*/ "./components/Contact");
import General from "./components/content/General";
import Ccc from './components/content/Ccc';
import Ep from "./components/content/Ep";
import Advhf from './components/content/Advhf';
import Advimg from "./components/content/Advimg";
import Noncards from "./components/content/Noncards";
import Other from "./components/content/Other";
import Interventional from "./components/content/Interventional";
import Algorithms from "./components/content/Algorithms";
import SubmissionFail from '@/components/SubmissionFail'
import SubmissionSuccess from "./components/SubmissionSuccess"
import Guides from '@/components/Guides'
const Join = () => import("@/components/Join");
const Meeting = () => import("@/components/Meeting");



export const routes = [
         {
           path: "/",
           name: "homeLink",
           components: {
             default: Home,
           },
           meta: {
             title: "Cardiology COVID-19 Coalition",
           },
         },

         { path: "/advocacy", name: "advocacyLink", component: Advocacy },
         {
           path: "/join",
           name: "join",
           component: Join,
         },
         {
           path: "/meeting",
           name: "meeting",
           component: Meeting,
         },
         { path: "/team", name: "teamLink", component: Team },
         { path: "/contact", name: "contactLink", component: Contact },
         { path: "/guides", name: "guidesLink", component: Guides },
         { path: "/general", name: "generalLink", component: General },
         { path: "/ccc", name: "cccLink", component: Ccc },
         { path: "/ep", name: "epLink", component: Ep },
         { path: "/advhf", name: "advhfLink", component: Advhf },
         { path: "/advimg", name: "advimgLink", component: Advimg },
         { path: "/noncards", name: "noncardsLink", component: Noncards },
         { path: "/other", name: "otherLink", component: Other },
         {
           path: "/interventional",
           name: "interventionalLink",
           component: Interventional,
         },
         {
           path: "/Algorithms",
           name: "algorithmsLink",
           component: Algorithms,
         },

         {
           path: "/about",
           name: "aboutLink",
           component: About,
         },
         {
           path: "/thanks",
           name: "success",
           component: SubmissionSuccess,
         },
         {
           path: "/404",
           name: "fail",
           component: SubmissionFail,
         },
       ];

